import {CartItemBuilder} from 'components/common/CartItemBuilder/CartItemBuilder'
import {DeleteModal} from 'components/common/DeleteModal'
import {Button} from 'components/system/Button'
import {ReactNode} from 'react'
import {useCallback, useState} from 'react'
import {Exp1, Ventrata} from 'types'
import {convertUnitItemsToUnitCounterMap} from 'utils/convertUnitItemsToUnitCounterMap'
import {CartItemData} from './CartItemData'

type Props = {
  booking: Ventrata.Booking
  exp1Product: Exp1.Product | null
  render: (cartItemData: ReactNode) => ReactNode
}

export const BasicCartItem = ({booking, exp1Product, render}: Props) => {
  const [modalIsShown, setModalIsShown] = useState(false)
  const [cartItemBuilderShown, setCartItemBuilderShown] = useState(false)
  const closeModal = useCallback(() => setModalIsShown(false), [])
  const showModal = useCallback(() => setModalIsShown(true), [])
  const showCartItemBuilder = useCallback(() => setCartItemBuilderShown(true), [])
  const closeCartItemBuilder = useCallback(() => setCartItemBuilderShown(false), [])

  return (
    <div>
      {render(
        <CartItemData booking={booking} exp1Product={exp1Product}>
          <div className="flex gap-2">
            <Button.Edit onClick={showCartItemBuilder} />
            <Button.Delete onClick={showModal} />
          </div>
        </CartItemData>
      )}
      {modalIsShown && <DeleteModal booking={booking} onClose={closeModal} />}
      {cartItemBuilderShown && (
        <CartItemBuilder
          onClose={closeCartItemBuilder}
          initialState={{
            id: booking.uuid,
            productId: booking.product.id,
            optionId: booking.option.id,
            availabilityId: booking.availability.id,
            unitCounters: convertUnitItemsToUnitCounterMap(booking.unitItems),
          }}
          action="editing"
          stepOrder="guestsFirst"
        />
      )}
    </div>
  )
}
